import { useAuth } from '@/contexts/AuthContext';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Clock, AlertTriangle } from 'lucide-react';

const SessionTimeoutWarning = () => {
  const { showTimeoutWarning, timeoutSeconds, extendSession, signOut } = useAuth();

  const handleStayLoggedIn = () => {
    extendSession();
  };

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <AlertDialog open={showTimeoutWarning}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-destructive/10">
              <AlertTriangle className="h-6 w-6 text-destructive" />
            </div>
            <AlertDialogTitle className="text-xl">Session Timeout Warning</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base pt-2">
            Your session will expire due to inactivity. You will be automatically logged out in:
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="flex items-center justify-center gap-3 py-6 px-4 bg-muted rounded-lg">
          <Clock className="h-8 w-8 text-primary animate-pulse" />
          <div className="text-center">
            <div className="text-4xl font-bold text-foreground tabular-nums">
              {timeoutSeconds}
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              {timeoutSeconds === 1 ? 'second' : 'seconds'} remaining
            </div>
          </div>
        </div>

        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={handleLogout} className="sm:w-auto">
            Log Out Now
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleStayLoggedIn} className="sm:w-auto">
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SessionTimeoutWarning;
